import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@/components/ui/collapsible";

export const SqlPanel = ({ sql }) => {
  const [open, setOpen] = useState(false);
  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger
        data-testid="sql-panel-trigger"
        className="flex items-center gap-2 text-sm font-medium text-[#0E6E52] hover:text-[#1D3730] transition-colors duration-200"
      >
        <ChevronRight className={`w-4 h-4 transition-transform duration-200 ${open ? "rotate-90" : ""}`} />
        How this was derived
      </CollapsibleTrigger>
      <CollapsibleContent>
        <pre
          data-testid="sql-panel-content"
          className="mt-3 bg-[#141E1A] text-[#DCE3DF] font-mono text-sm p-4 rounded-md overflow-x-auto whitespace-pre-wrap"
        >
          {sql}
        </pre>
      </CollapsibleContent>
    </Collapsible>
  );
};
